import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import inspectionsReducer from "../features/inspectionsSlice";
import userReducer from "../features/userSlice";
import quotationsReducer from "../features/quotationsSlice";
import instantQuotationReducer from "../features/instantQuotationSlice";
import orderInspectionReducer from "../features/orderInspectionSlice";
import screeningReducer from "../features/screeningSlice";

export const store = configureStore( {
    reducer: {
        Inspections: inspectionsReducer,
        User: userReducer,
        Quotations: quotationsReducer,
        InstantQuotation: instantQuotationReducer,
        OrderInspection: orderInspectionReducer,
        Screening: screeningReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
});

export function setupStore(preloadedState?: Partial<RootState>) {
    return configureStore({
        reducer: {
            Inspections: inspectionsReducer,
            User: userReducer,
            Quotations: quotationsReducer,
            InstantQuotation: instantQuotationReducer,
            OrderInspection: orderInspectionReducer,
            Screening: screeningReducer,
        },
        preloadedState
    })
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type AppStore = ReturnType<typeof setupStore>
